"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _rating = require("@citrus/rating");
var _inputNumberStepper = require("@citrus/input-number-stepper");
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _questionBuilder = require("@pcty/question-builder");
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    scenario = _ref.scenario,
    question = _ref.question,
    hint = _ref.hint,
    number = _ref.number,
    starCount = _ref.starCount,
    value = _ref.value,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated,
    questionCommentsEnabled = _ref.questionCommentsEnabled,
    allowComments = _ref.allowComments,
    commentsPlaceholder = _ref.commentsPlaceholder;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.starRating;
  var min = 2;
  var max = 10;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onChangeStarRatingNumberStepper = function onChangeStarRatingNumberStepper(id, value) {
    var updatedCount = value > 0 ? value : 1;
    if (onQuestionUpdated) onQuestionUpdated({
      starCount: updatedCount
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_rating.StarRating, {
    id: id,
    number: starCount || 5,
    value: value
  }))), editable && /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row pcty-margin-top pcty-padding-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-4"
  }, /*#__PURE__*/_react.default.createElement(_inputNumberStepper.NumberStepper, {
    footnote: "Minimum: ".concat(min, ". Maximum: ").concat(max, "."),
    formatter: function formatter(x) {
      if ((0, _isNotNullOrEmpty.default)(x) && parseInt(Math.floor(x)) > 0) {
        return x.toString().split('').reduce(function (aggregator, item, index) {
          return aggregator + item;
        }, '') + ' stars';
      }
      return '';
    },
    id: "".concat(id, "-edit-starrating"),
    label: "Star Rating Scale",
    max: max,
    min: min,
    onChange: onChangeStarRatingNumberStepper,
    value: starCount || 5
  }))), (0, _PctyQuestionBuilder.renderQuestionComment)(id, allowComments, commentsPlaceholder, editable, questionCommentsEnabled, onQuestionUpdated));
};
var _default = exports.default = Presentational;